<template lang="pug">
  .configure(:data-product="buyRequest.productId")
    giftcard-configuration(
      v-if="product.type === 'giftcard' && buyRequest.metadata"
      :value="buyRequest.metadata.giftcard"
    )
    Configuration(
      v-if="product.type === 'configurable' && buyRequest.children && buyRequest.children[0]"
      :buy-request="buyRequest"
      @update="update()"
    )
    CustomOptions(
      v-if="childHasOptions"
      @update="update()"
      :buy-request="buyRequest.children[0]"
    )
    CustomOptions(
      v-if="!hideCustomOptions"
      @update="update()"
      :buy-request="buyRequest"
    )
</template>
<script>
import { defineAsyncComponent } from 'vue'
import { useListStore } from '@/js/stores/listStore'
import { useProductStore } from '@/js/stores/productStore'
import stockStatus from '@/js/helpers/stockStatus'

export default {
  name       : 'configure-buy-request',
  components : {
    GiftcardConfiguration : defineAsyncComponent(() => import(/* webpackChunkName: "giftcard" */'@/js/components/rhpa/giftcard-configuration.vue')),
    CustomOptions         : defineAsyncComponent(() => import(/* webpackChunkName: "custom-options" */'@/js/components/rhpa/custom-options.vue')),
  },

  props: {
    buyRequest: {
      type     : Object,
      required : true,
    },
    list: {
      type    : String,
      default : null,
    },
  },

  setup() {
    const listStore = useListStore()
    const productStore = useProductStore()

    return {
      listStore,
      productStore,
    }
  },

  computed: {
    products() {
      return this.productStore.products
    },

    childHasOptions() {
      return this.product.type === 'configurable'
        && this.buyRequest.children?.length
        && this.products[this.buyRequest.children[0]?.productId]?.customOptions?.length
    },

    product() {
      return this.products[this.buyRequest.productId]
    },

    hideCustomOptions() {
      const stock = stockStatus.forBuyRequest(this.buyRequest, this.products)

      return !this.product.customOptions?.length
        || (this.product.type === 'simple' && ['bin', 'oos'].includes(stock))
    },
  },

  methods: {
    update() {
      const listItemId = this.buyRequest._id
      if (this.list && listItemId) {
        this.listStore.updateListItem(this.$rogue, this.list, listItemId, this.buyRequest)
      }
    },
  },
}
</script>
<style lang="scss">

</style>
